export default __webpack_public_path__ + "static/media/medicalTestIconDisabled.5bd2f1fe.svg";